import React, { useEffect, useState } from 'react';

import { gsap } from 'gsap';

import './Loader.scss';
// TODO Find why the warnings are being triggered in the first place
gsap.config({ nullTargetWarn: false });
const emojis = [
    ['📷', '🤖', '💎'],
    ['❤️', '🦄', ''],
    ['🐱', '🐻', '💎'],
];

export const YatV2Loader = () => {
    const [tiles, setTiles] = useState<Array<HTMLDivElement | null>>([]);

    useEffect(() => {
        let count = 0;
        emojis.forEach((emojiLine) =>
            emojiLine.forEach(() => {
                count++;
            }),
        );
        setTiles(new Array(count).fill(null));
    }, []);

    useEffect(() => {
        if (tiles.length < 9) {
            return;
        }

        tiles.forEach((_, i) => {
            if (i % 3 !== 0) {
                gsap.set(tiles[i], { yPercent: 100, opacity: 0, delay: 0 });
            }
        });

        const tl = gsap.timeline({
            repeat: -1,
            defaults: {
                duration: 0.3,
                delay: 0.25,
                ease: 'expo.easeOut',
            },
        });

        const bottomPos = { yPercent: 100, opacity: 0 };
        const centerPos = { yPercent: 0, opacity: 1 };
        const topPos = { yPercent: -100, opacity: 0 };

        tiles.forEach((_, i) => {
            if (i % 3 !== 0) {
                tl.set(tiles[i], { yPercent: 100, opacity: 0, delay: 0 });
            } else {
                tl.set(tiles[i], { yPercent: 0, opacity: 1, delay: 0 });
            }
        });

        tl.addLabel('shift1')
            .fromTo(tiles[0], centerPos, topPos, 'shift1')
            .fromTo(tiles[1], bottomPos, centerPos, 'shift1')

            .addLabel('shift2')
            .fromTo(tiles[3], centerPos, topPos, 'shift2')
            .fromTo(tiles[4], bottomPos, centerPos, 'shift2')

            .fromTo(tiles[6], centerPos, topPos, 'shift2')
            .fromTo(tiles[7], bottomPos, centerPos, 'shift2')

            .addLabel('shift3')
            .fromTo(tiles[1], centerPos, topPos, 'shift3')
            .fromTo(tiles[2], bottomPos, centerPos, 'shift3')

            .fromTo(tiles[7], centerPos, topPos, 'shift3')
            .fromTo(tiles[8], bottomPos, centerPos, 'shift3')

            .addLabel('shift4')
            .fromTo(tiles[2], centerPos, topPos, 'shift4')
            .fromTo(tiles[0], bottomPos, centerPos, 'shift4')

            .fromTo(tiles[4], centerPos, topPos, 'shift4')
            .fromTo(tiles[3], bottomPos, centerPos, 'shift4')

            .fromTo(tiles[8], centerPos, topPos, 'shift4')
            .fromTo(tiles[6], bottomPos, centerPos, 'shift4');
        // This dependency is required for the animation.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tiles]);

    return (
        <div className="yat-v2-loader">
            <div>
                <div className="yat-v2-loader__container">
                    {emojis.map((emojiLine, index) => (
                        <div key={index} className="yat-v2-loader__slot">
                            {emojiLine.map((emoji, i) => (
                                <div
                                    className="yat-v2-loader__tile"
                                    key={`${index}-${i}`}
                                    ref={(el) => (tiles[index * 3 + i] = el)}
                                >
                                    {emoji}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
